import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';
import { CoreContext } from '../context/index.js';
import '../utils/logToSlack.js';
import 'lodash/get';
import '../product-_pRduMz7.js';
import '../helpers-qyZpLI0y.js';
import 'cookies-next';
import '../currency-_kacFJHO.js';
import '../language-BHHwgtQp.js';
import '../payment-5CMab_Gs.js';
import 'lodash';
import { p as pageView } from '../pageView-EPLyidHy.js';
import '../utils/product.js';
import '../paths-ZKN3m62_.js';
import '../cookies-l-jEMp6P.js';
import '../utils/logger.js';
import '../utils/dataRouteFormat.js';
import '../utils/auth.js';
import '../index-QrdBfapu.js';
import '../utils/cookies.js';
import '../utils/isBot.js';

const usePageViewEvent = (options) => {
    const { category, virtualPath } = options || {};
    const { route, asPath } = useRouter();
    const { data: { siteConfig: { catalogId, overrideDataLayerRoutes = [], accorTagging: { pageNamePrefix = undefined } = {}, }, }, } = useContext(CoreContext);
    useEffect(() => {
        console.log('page view ', pageNamePrefix);
        pageView(route, pageNamePrefix || catalogId, asPath, overrideDataLayerRoutes, category, virtualPath);
    }, [asPath]);
};

export { usePageViewEvent as default };
//# sourceMappingURL=usePageViewEvent.js.map
